<script>

import Navbar from '@/components/Navbar'
import htmlEn from '@/assets/generated/rclone-ionos.en.html'
import htmlDe from '@/assets/generated/rclone-ionos.de.html'

export default {
  name: 'rclone-ionos',
  components: { Navbar },
  computed: {
    raw3(){
      return this.$i18n.locale === 'de' ? htmlDe : htmlEn;
    }
  }
}
</script>

<template>
  <div>
    <navbar :lightTheme="true" :blogpost="true" />
    <div id="raw" v-html="raw3"></div>
  </div>
</template>

<style lang="scss" scoped>
  @import "@/assets/css/fcc.scss"; 
</style>

